export default "/_next/static/ffb20173601ff32071163aa6989855b6.svg";